import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { useCallback, useEffect, useRef, useState } from "react";
import PlanFilesAPI, { ACCEPT, MAX_FILE_MB, checkFile, formatSize } from "../../../API/PlanFilesAPI";

// The documents of one plan / order: list, add, download, delete.
// Use it on any screen that has the plan:  <PlanDocuments planId={props.planDetails.id} />
// Goes in src/components/UI/PlanDocuments/PlanDocuments.js
const PlanDocuments = ({ planId }) => {
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const input = useRef(null);

  const load = useCallback(async () => {
    if (!planId) return;
    try {
      setFiles(await PlanFilesAPI.list(planId));
    } catch (e) {
      setError(e.message);
    }
  }, [planId]);

  useEffect(() => {
    load();
  }, [load]);

  const pick = async (e) => {
    const chosen = Array.from(e.target.files || []);
    e.target.value = ""; // the same file can be chosen again
    const problems = chosen.map(checkFile).filter(Boolean);
    if (problems.length) {
      setError(problems.join(". "));
      return;
    }
    setBusy(true);
    setError("");
    const failed = [];
    for (const file of chosen) {
      try {
        await PlanFilesAPI.upload(planId, file);
      } catch (err) {
        failed.push(err.message);
      }
    }
    setBusy(false);
    if (failed.length) setError(failed.join(". "));
    load();
  };

  const run = async (action) => {
    setError("");
    try {
      await action();
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div className="plan-documents" style={{ margin: "16px 24px" }}>
      <h6 style={{ color: "#00a352" }}>Dokumente by hierdie bestelling</h6>
      {files.length === 0 && <div style={{ color: "#595959", fontSize: "0.9rem" }}>Geen dokumente gestoor nie.</div>}
      {files.map((f) => (
        <div key={f.id} style={{ display: "flex", gap: 8, alignItems: "center", padding: "2px 0" }}>
          <i className="pi pi-file" />
          <span style={{ flex: "0 1 auto" }}>{f.filename}</span>
          <span style={{ color: "#595959", fontSize: "0.85rem" }}>{formatSize(f.size_bytes)}</span>
          <Button icon="pi pi-download" className="p-button-text p-button-sm" aria-label="Laai af" onClick={() => run(() => PlanFilesAPI.download(f.id, f.filename))} />
          <Button icon="pi pi-times" className="p-button-text p-button-sm p-button-danger" aria-label="Verwyder" onClick={() => run(async () => { await PlanFilesAPI.remove(f.id); await load(); })} />
        </div>
      ))}
      <input ref={input} type="file" accept={ACCEPT} multiple style={{ display: "none" }} onChange={pick} />
      <Button label="Stoor dokument" icon="pi pi-upload" className="p-button-outlined mt-2" disabled={busy} onClick={() => input.current && input.current.click()} />
      <span style={{ marginLeft: 8, color: "#595959", fontSize: "0.8rem" }}>enige lêer, tot {MAX_FILE_MB} MB</span>
      {error && <Message severity="error" text={error} className="mt-2" />}
    </div>
  );
};

export default PlanDocuments;
